import { ButtonContentLink } from '@fukku/button/ContentLink'
import { ContextualMessage } from 'fukku/ContextualMessage'
import { CONTEXTUAL_MESSAGE_TYPE } from 'fukku/ContextualMessage/ContextualMessage'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import style from './PartialPurchasesError.module.scss'

interface PartialPurchasesErrorProps {
	readonly reload: () => void
}

export function PartialPurchasesError({ reload }: PartialPurchasesErrorProps) {
	const { t } = useLabels()
	return (
		<ContextualMessage
			className={style.container}
			type={CONTEXTUAL_MESSAGE_TYPE.ERROR}
			message={t('myPurchases.error.loadingPurchases.bodycopy')}
			link={
				<ButtonContentLink
					className={style.reloadBtn}
					onClick={reload}
					data-testid='myPurchases.error.loadingPurchases.retry.button'
				>
					{t('myPurchases.error.loadingPurchases.retry.button')}
				</ButtonContentLink>
			}
		/>
	)
}
